import React from 'react'

function Services() {
  return (
    <div>
          <div className="container-fluid bg-primary py-5 mb-5 hero-header">
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
            Services
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                Services
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
      {/* Service Start */}
      <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Services
          </h6>
          <h1 className="mb-5">Our Services</h1>
        </div>
        <div className="row g-4">
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
                <i className="fas fa-3x fa-globe text-primary mb-4" style={{fontWeight: 900}} />
                <h5>WorldWide Tours</h5>
                <p>
                  Explore breathtaking destinations across the globe with our expertly curated worldwide tour packages
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
                <i className="fas fa-3x fa-hotel text-primary mb-4" style={{fontWeight: 900}} />
                <h5>Hotel Reservation</h5>
                <p>
                  Book premium accommodations at the best rates with our extensive network of partner hotels worldwide
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
                <i className="fas fa-3x fa-user text-primary mb-4" style={{fontWeight: 900}} />
                <h5>Travel Guides</h5>
                <p>
                  Connect with experienced local guides who will enhance your journey with insider knowledge and authentic experiences
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
                <i className="fas fa-3x fa-cog text-primary mb-4" style={{fontWeight: 900}} />
                <h5>Event Management</h5>
                <p>
                  Plan and execute memorable events, corporate retreats, and special celebrations at stunning destinations
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
                <i className="fas fa-3x fa-plane text-primary mb-4" style={{fontWeight: 900}} />
                <h5>Flight Booking</h5>
                <p>
                  Secure the best flight deals with our comprehensive booking service, connecting you to destinations worldwide
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
                <i className="fas fa-3x fa-shield-alt text-primary mb-4" style={{fontWeight: 900}} />
                <h5>Travel Insurance</h5>
                <p>
                  Protect your journey with comprehensive travel insurance coverage for peace of mind during your adventures
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
                <i className="fas fa-3x fa-passport text-primary mb-4" style={{fontWeight: 900}} />
                <h5>Visa Assistance</h5>
                <p>
                  Get expert help with visa applications and documentation to ensure smooth entry to your dream destinations
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
                <i className="fas fa-3x fa-car text-primary mb-4" style={{fontWeight: 900}} />
                <h5>Car Rental</h5>
                <p>
                  Rent reliable vehicles at competitive prices to explore your destination at your own pace and convenience
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Service End */}
    {/* Testimonial Start */}
    {/* <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container">
        <div className="text-center">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Testimonial
          </h6>
          <h1 className="mb-5">Our Clients Say!!!</h1>
        </div>
        <div className="owl-carousel testimonial-carousel position-relative">
          <div className="testimonial-item bg-white text-center border p-4">
            <img
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-1.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">Sarah Johnson</h5>
            <p>New York, USA</p>
            <p className="mb-0">
              Holiday Royal made our honeymoon absolutely perfect! Every detail was taken care of, and we had the most amazing experience. Highly recommend!
            </p>
          </div>
          <div className="testimonial-item bg-white text-center border p-4">
            <img
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-2.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">John Doe</h5>
            <p>New York, USA</p>
            <p className="mt-2 mb-0">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
              amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>
          </div>
          <div className="testimonial-item bg-white text-center border p-4">
            <img
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-3.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">Emily Rodriguez</h5>
            <p>Miami, USA</p>
            <p className="mt-2 mb-0">
              The attention to detail and personalized service from Holiday Royal was outstanding. They truly understand what makes a perfect vacation!
            </p>
          </div>
          <div className="testimonial-item bg-white text-center border p-4">
            <img
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-4.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">David Thompson</h5>
            <p>Chicago, USA</p>
            <p className="mt-2 mb-0">
              Best travel agency we've ever used! Holiday Royal made our European tour seamless and unforgettable. Will definitely book with them again!
            </p>
          </div>
        </div>
      </div>
    </div> */}
    {/* Testimonial End */}
    </div>
  )
}

export default Services
